import React, { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import "../vendor-panel.css";
import logo from "../assets/vangle.jpeg";

const NAV_ITEMS = [
  { path: "/vendor/dashboard", label: "Dashboard", icon: (
    <svg width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><rect x="3" y="3" width="7" height="7" rx="1"/><rect x="14" y="3" width="7" height="7" rx="1"/><rect x="3" y="14" width="7" height="7" rx="1"/><rect x="14" y="14" width="7" height="7" rx="1"/></svg>
  )},
  { path: "/vendor/all-orders", label: "All Orders", icon: (
    <svg width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2"/><rect x="9" y="3" width="6" height="4" rx="1"/><path d="M9 12h6M9 16h4"/></svg>
  )},
  { path: "/vendor/items", label: "Manage Items", icon: (
    <svg width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path d="M20 7H4a1 1 0 00-1 1v10a1 1 0 001 1h16a1 1 0 001-1V8a1 1 0 00-1-1z"/><path d="M16 7V5a2 2 0 00-2-2h-4a2 2 0 00-2 2v2"/></svg>
  )},
  { path: "/vendor/profile", label: "My Profile", icon: (
    <svg width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path d="M20 21v-2a4 4 0 00-4-4H8a4 4 0 00-4 4v2"/><circle cx="12" cy="7" r="4"/></svg>
  )},
];

const PAGE_TITLES = {
  "/vendor/dashboard": { title: "Dashboard", sub: "Overview of your business" },
  "/vendor/all-orders": { title: "All Orders", sub: "Manage and track customer orders" },
  "/vendor/items": { title: "Manage Items", sub: "Add, edit and remove products" },
  "/vendor/profile": { title: "My Profile", sub: "Update your business information" },
};

const VendorLayout = ({ children, vendorName }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [sidebarOpen, setSidebarOpen] = useState(false);

  const handleLogout = () => {
    localStorage.removeItem("vendorToken");
    navigate("/vendor/login");
  };

  const page = PAGE_TITLES[location.pathname] || { title: "Vendor Panel", sub: "" };
  const initials = vendorName ? vendorName.charAt(0).toUpperCase() : "V";

  return (
    <div className="vp-layout">
      {/* Mobile overlay */}
      <div
        className={`vp-overlay ${sidebarOpen ? "visible" : ""}`}
        onClick={() => setSidebarOpen(false)}
      />

      {/* Sidebar */}
      <aside className={`vp-sidebar ${sidebarOpen ? "open" : ""}`}>
        <div className="vp-sidebar-logo">
          <img src={logo} alt="Logo" />
          <span>
            V Angel Coin
            <em>Vendor Panel</em>
          </span>
        </div>

        <nav className="vp-nav">
          <div className="vp-nav-label">Menu</div>
          {NAV_ITEMS.map(item => (
            <div
              key={item.path}
              className={`vp-nav-item ${location.pathname === item.path ? "active" : ""}`}
              onClick={() => { navigate(item.path); setSidebarOpen(false); }}
            >
              {item.icon}
              {item.label}
            </div>
          ))}
        </nav>

        <div className="vp-sidebar-footer">
          <button className="vp-logout-btn" onClick={handleLogout}>
            <svg width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
              <path d="M9 21H5a2 2 0 01-2-2V5a2 2 0 012-2h4M16 17l5-5-5-5M21 12H9"/>
            </svg>
            Logout
          </button>
        </div>
      </aside>

      {/* Main */}
      <div className="vp-main">
        {/* Header */}
        <header className="vp-header">
          <div className="vp-header-left">
            <button className="vp-menu-toggle" onClick={() => setSidebarOpen(!sidebarOpen)}>
              <svg width="20" height="20" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
                <path d="M3 12h18M3 6h18M3 18h18"/>
              </svg>
            </button>
            <div>
              <div className="vp-header-title">{page.title}</div>
              {page.sub && <div className="vp-header-subtitle">{page.sub}</div>}
            </div>
          </div>

          <div className="vp-header-right">
            {vendorName && (
              <div style={{ textAlign: "right" }}>
                <div className="vp-header-name">{vendorName}</div>
                <div className="vp-header-role">Vendor</div>
              </div>
            )}
            <div className="vp-header-avatar">{initials}</div>
          </div>
        </header>

        {/* Content */}
        <main className="vp-content">
          {children}
        </main>
      </div>
    </div>
  );
};

export default VendorLayout;
